import { call, put } from "redux-saga/effects";

import actions from "@/actions";
import { Api } from "@/utils";

/**
 * Loads site data from the API and stores it in the Redux state.
 *
 * @param root0 - The action payload.
 * @param root0.siteId - The site ID to load.
 * @returns The loaded site data.
 * @yields Calls the API and dispatches site data.
 */
function* loadSite({ siteId }) {
    const site = yield call(Api.get, `v1/sites/${siteId}`);
    yield put(actions.map.general.setSite(site));
    return site;
}

export default loadSite;
